import { connect } from "react-redux";

import type { TravelReviewStats } from "@busbud/core-types/dist/lib/grand-central/api";
import type { MappedOperator } from "@busbud/int-schemas/udm";

import { getProfileIdByOperatorId } from "@app/modules/results/selectors/get-profile-id-by-operator-id";
import { getOperatorProfileRatingById } from "@app/modules/results/selectors/get-profile-rating-by-id";
import { getLegAmenities } from "@app/modules/results/selectors/legs/get-leg-amenities";
import { getDisplayOperator } from "@app/modules/results/selectors/trips/get-trip-operators";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import type { TripOperatorRatingCategory } from "../helpers/operator-ratings";
import type { ConnectedProps } from "react-redux";

import { OperatorRatings as OperatorRatingsComponent } from "./operator-ratings";
import { getTripOperatorCategoryRatings } from "../helpers/operator-ratings";

interface StateProps {
  profile_id: number | undefined;
  display_operator: MappedOperator | null;
  display_operator_rating: TravelReviewStats | null;
  rating_categories: TripOperatorRatingCategory[];
}

interface OwnProps {
  trip_id: string | undefined;
}

const DEFAULT_STATE = {
  profile_id: undefined,
  display_operator: null,
  display_operator_rating: null,
  rating_categories: []
};

const mapStateToProps = (
  state: ResultsReduxState,
  ownProps: OwnProps
): StateProps => {
  const { trip_id } = ownProps;

  if (!trip_id) {
    return DEFAULT_STATE;
  }

  const display_operator = getDisplayOperator(state, trip_id);
  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const profile_rating = display_operator.profile_id
    ? // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      getOperatorProfileRatingById(state, display_operator.profile_id)
    : null;

  if (!profile_rating) {
    return DEFAULT_STATE;
  }

  const amenities = getLegAmenities(state, trip_id);
  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const profile_id = getProfileIdByOperatorId(state, display_operator.id);

  const rating_categories = getTripOperatorCategoryRatings(
    profile_rating,
    amenities
  );

  const props: StateProps = {
    profile_id,
    // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    display_operator,
    display_operator_rating: profile_rating,
    rating_categories
  };

  return props;
};

const connector = connect(mapStateToProps);

export type ConnectorProps = ConnectedProps<typeof connector>;

export const OperatorRatings = connector(OperatorRatingsComponent);
